import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';
import Layout from "../layout";
import pages from '../../subscriber/Pages';
import staticBlogs from '../../data/blogs.json';
import SeoHelmet from '../../components/SeoHelmet';
import HeroSection from '../../components/HeroSection';
import { languageStore } from '../../subscriber/Language';
import { getArray, getArrayLength } from '../../utils/helpers';
import { getProjects } from '../../provider/Service';
// Import images
import heroImage from "../../assets/chef_luca_cooking_in_kitchen.png";

const ProjectsPage = observer(() => {
    const { projects } = pages

    useEffect(() => {
        if (getArrayLength(projects) === 0) {
            getProjects();
        }
    }, [projects]);

    const { getPageTranslations } = languageStore;
    const t = getPageTranslations('projects');

    // 👇 SEO meta only from Home
    const seoProjects = staticBlogs.find(b => b.slug === 'projects');

    return (
        <Layout>
            <SeoHelmet
                title={seoProjects.name}
                description={seoProjects.sort_description}
                image={seoProjects.path}
                url={seoProjects.url}
            />
            <div className="bg-[#FFEDE1]">
                {/* Hero Section */}
                <HeroSection 
                    backgroundImage={heroImage}
                    title={t?.title}
                />
                
                {/* Services Content */}
                <section className="py-24 px-4 bg-[#fff]">
                    <div className="max-w-6xl mx-auto">
                        <div className="px-[17%]">
                            <h5 className="text-[#C7702A] font-jost text-base font-normal uppercase mb-2 text-center">{t.title}</h5>
                            <h2 className="text-[#1F0707] text-[45px] font-medium leading-[1.2em] tracking-[-0.015em] mb-12 font-libre-caslon text-center">{t.subtitle}</h2>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                            {getArray(projects).map((project, index) => (
                                <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg">
                                    <Link to={`service_detail/${project?.slug}`} className="block">
                                        <img 
                                            src={project?.image} 
                                            alt={project?.name} 
                                            width={300}
                                            height={200}
                                            className="w-full h-64 object-cover duration-300 hover:scale-105"
                                        />
                                        <div className="p-6">
                                            <h4 className="text-[#1F0707] font-['Libre_Caslon_Display',sans-serif] text-[28px] font-libre-caslon font-normal leading-[28.8px] mb-[6px] mt-0 text-size-adjust-100 unicode-bidi-isolate word-spacing-0">{project.name}</h4>
                                            <p className="text-[rgba(31,7,7,0.62)] font-['Jost',sans-serif] text-[14px] font-normal leading-[28.8px] mb-[14.4px] text-size-adjust-100 unicode-bidi-isolate">{project.sort_description}</p>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        </Layout>
    );
});

export default ProjectsPage;
